module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAZUlEQVQYGY3BwQ2AIBBFwfcjfbj9uOViP9jHGlwSD4QTM2KT2CQW0WonFXMxEYtotZOKuZiIX7TaScd5MbzPzVDMRRK/aLWTjvNieJ+boZiLJBbRaicVczERi2i1k4q5mIhNYtMHRFEeC1mlcb0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/flappybird/blink_01.png
// module id = 194
// module chunks = 0